import { useSelector } from "react-redux";
import { Overlay, LoadingSpinner } from "../../../pages/AddUserPage/AddUser";
import ContentWrapper from "../ContentWrapper";
import PaymentLinkNavbar from "../Navbar";
import PaymentLinkSidebar from "../Sidebar";

import {
  MainContainer,
  PaymentLinkSecondContainer,
  PaymentNavbar,
  PaymentSidebar,
} from "./PaymentLinkPage.styles";
import { RootState } from "../../../store/rootReducer";

const DashboardLayout = ({ children }: any) => {
  const { isLoading } = useSelector((state: RootState) => state.loadingSpinner);

  return (
    <MainContainer>
      {isLoading && (
        <Overlay>
          <LoadingSpinner />
        </Overlay>
      )}
      <PaymentLinkSecondContainer>
        <PaymentSidebar>
          <PaymentLinkSidebar />
        </PaymentSidebar>
        <PaymentNavbar>
          <PaymentLinkNavbar />
          <ContentWrapper hideHeader>{children}</ContentWrapper>
        </PaymentNavbar>
      </PaymentLinkSecondContainer>
    </MainContainer>
  );
};

export default DashboardLayout;
